import * as trustScoreThresholds from '@/constants/trustScoreThresholds';

export const trustScoreRank = (score) => {
  let rank;
  if (score <= trustScoreThresholds.LOW) rank = 'Low';
  else if (score >= trustScoreThresholds.HIGH) rank = 'High';
  else rank = 'Average';

  return rank.toLowerCase();
};
